import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import ComputedMetricsContent from '../Metrics/ComputedMetricsContent';

interface ComputedMetricsDialogProps {
  open: boolean;
  onClose: () => void;
  reviewEntityId: number | null;
}

const ComputedMetricsDialog: React.FC<ComputedMetricsDialogProps> = ({ 
  open, 
  onClose, 
  reviewEntityId,
}) => {
  return (
    <Dialog 
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogContent dividers sx={{ px: 2, py: 2 }}>
        <ComputedMetricsContent
          initialEntityId={reviewEntityId}
          hideEntitySelectors={true}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComputedMetricsDialog;
